import { useOnClickOutside } from '../hooks/useOnClickOutside';
import { CloseIcon } from '@raysee/icon';
import { FC, useRef } from 'react';

interface Props {
  isOpen: boolean;
  showCloseIcon?: boolean;
  hiddenBackground?: boolean;
  transparency?: 'ligth' | 'dark';
  onClose: () => void;
}

export const Modal: FC<Props> = ({
  isOpen,
  showCloseIcon = true,
  hiddenBackground,
  transparency = 'ligth',
  onClose,
  children,
}) => {
  const ref = useRef();
  useOnClickOutside(ref, onClose);

  return (
    <div
      className={`hs-modal fixed left-0 top-0 z-[9999999] h-full w-full overflow-y-auto overflow-x-hidden ${
        isOpen ? 'open' : 'hidden'
      } ${transparency === 'dark' ? 'bg-gray-900/70' : 'bg-gray-900/60'}`}
    >
      <div className="hs-modal-open:mt-8 hs-modal-open:opacity-100 hs-modal-open:duration-500 flex min-h-[calc(100%-3.5rem)] items-center justify-center transition-all ease-out">
        <div
          className={`relative m-4 rounded-lg shadow ${hiddenBackground ? '' : 'border bg-white'}`}
        >
          {showCloseIcon && (
            <a className="absolute right-0 top-[-40px] cursor-pointer">
              <CloseIcon width={22} height={22} />
            </a>
          )}
          <div ref={ref}>{children}</div>
        </div>
      </div>
    </div>
  );
};
